import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core'
import { IGroupeState, groupeFacadeBase } from './groupe.state';
import { Groupe } from './groupe.model';
import { GroupeService } from './groupe.service';
import { Criteria } from 'app/shared/utils/criteria.model';
import { Observable } from 'rxjs';

@Injectable()
export class GroupeFacade extends groupeFacadeBase {


    constructor(_store: Store<IGroupeState>, private _groupeService: GroupeService) {
        super(Groupe, _store);
    }
/*
    loadAllSelect(criteria?: Criteria): Observable<Groupe[]> {
        return this._groupeService.loadAllSelect(criteria);
    }
*/
}
